import React, { useState } from "react";
import ComboboxInput from "./Reusable/ComboboxInput";
import TextField from "./Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../constant/EndPoint";
import Button from "./Reusable/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { createRiderValidationForm } from "../utils/validationSchemas";
import Modal from "./Reusable/Modal";
import { responsiveClassName } from "../utils/classNames";

const DriverForm = (props: any) => {
  const { handleAddDriver, isDriverLoading } = props;
  const {
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm<any>({
    resolver: yupResolver(createRiderValidationForm),
  });
  return (
    <>
      <form
        onSubmit={handleSubmit((data: any) => handleAddDriver(data, setError))}
      >
        <div
          className={responsiveClassName(
            `grid  grid-cols-1 gap-x-4 mx-4`,
            "grid  grid-cols-2 gap-x-4 mx-4"
          )}
        >
          <TextField
            label={"Username"}
            register={register("username")}
            errors={errors?.username}
          />
          <TextField
            label={"Full Name"}
            register={register("full_name")}
            errors={errors?.full_name}
          />
          <TextField
            label={"Email"}
            register={register("email")}
            errors={errors?.email}
          />
          <TextField
            label={"Mobile Number"}
            register={register("mobile_number")}
            errors={errors?.mobile_number}
          />
          <TextField
            label={"License Number"}
            register={register("license_number")}
            errors={errors?.license_number}
          />
          <TextField
            label={"Ctitizenship Number"}
            register={register("citizenship_number")}
            errors={errors?.citizenship_number}
          />
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("branch")}
            errors={errors?.branch}
            name={"branch"}
            label={"Branch"}
            setValue={setValue}
            placeholder={"Search branch..."}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
        <div className={tw`flex w-full justify-end`}>
          <div className={tw`w-32`}>
            <Button label={"Create"} isLoading={isDriverLoading} />
          </div>
        </div>
      </form>
    </>
  );
};

export default DriverForm;
